import React from 'react'
import IconButterfly from '@/components/icons/IconButterfly/IconButterfly'
import IconScale from '@/components/icons/IconScale/IconScale'
import IconReading from '@/components/icons/IconReading/IconReading'
import IconWateringPlants from '@/components/icons/IconWateringPlants/IconWateringPlants'
import Button from '@/components/atoms/Button/ButtonV2'

const OurValues: React.FC = () => {
  return (
    <div className="flex flex-col items-start gap-6">
      <p className="font-FieldsVariable text-2xl font-medium text-gray-1100">
        Our Values
      </p>
      <div className="flex w-full flex-col gap-8 xl:flex-row">
        <div className="flex flex-col items-start gap-8 self-stretch md:flex-row">
          <div className="flex basis-1/2 items-center gap-4">
            <div className="flex size-16 shrink-0 items-center justify-center rounded-xl bg-amber-100 md:size-20">
              <IconButterfly customCss="text-gray-1100 h-6 w-6 md:h-8 md:w-8" />
            </div>
            <div className="text-lg font-medium text-gray-1100">
              Independent and Unbiased
            </div>
          </div>
          <div className="flex basis-1/2 items-center gap-4">
            <div className="flex size-16 shrink-0 items-center justify-center rounded-xl bg-amber-100 md:size-20">
              <IconScale customCss="text-gray-1100 h-6 w-6 md:h-8 md:w-8" />
            </div>
            <div className="text-lg font-medium text-gray-1100">
              Ethical and Transparent Practices
            </div>
          </div>
        </div>
        <div className="flex flex-col items-start gap-8 self-stretch md:flex-row">
          <div className="flex basis-1/2 items-center gap-4">
            <div className="flex size-16 shrink-0 items-center justify-center rounded-xl bg-amber-100 md:size-20">
              <IconReading customCss="text-gray-1100 h-6 w-6 md:h-8 md:w-8" />
            </div>
            <div className="text-lg font-medium text-gray-1100">
              Helpful and Educational
            </div>
          </div>
          <div className="flex basis-1/2 items-center gap-4">
            <div className="flex size-16 shrink-0 items-center justify-center rounded-xl bg-amber-100 md:size-20">
              <IconWateringPlants customCss="text-gray-1100 h-6 w-6 md:h-8 md:w-8" />
            </div>
            <div className="text-lg font-medium text-gray-1100">
              Comprehensive and Always Evolving
            </div>
          </div>
        </div>
      </div>
      <Button
        className="w-full md:w-auto xl:hidden"
        type="tertiary"
        as="a"
        href="/about/"
      >
        Learn More
      </Button>
    </div>
  )
}

export default OurValues
